import { NormalizedCacheObject } from 'apollo-boost';

import { MarketersHelper } from '../service/MarketersHelper';
import { MarketerAddProductForm, MarketerProduct } from '../typings/marketers';

import { BaseDataProvider } from './BaseDataProvider/BaseDataProvider';
import { DNAApolloClient } from './DNAApolloClient/DNAApolloClient';
import { RestApiManager } from './RestApiManager';

export class MarketersDataProvider extends BaseDataProvider {
    private apiManager: RestApiManager;

    constructor(
        apiManager: RestApiManager,
        client: DNAApolloClient<NormalizedCacheObject>
    ) {
        super(client);
        this.apiManager = apiManager;
    }

    public fetchMarketersData() {
        return this.apiManager
            .fetchMarketersList()
            .then(res =>
                res.result.map(marketer =>
                    MarketersHelper.getMarketer(marketer)
                )
            );
    }

    public fetchMarketerCardData(id: string) {
        return this.apiManager
            .fetchMarketerCard(id)
            .then(res => MarketersHelper.getMarketer(res.result));
    }

    public fetchMarketerAddProduct(
        form: MarketerAddProductForm,
        marketerId: string
    ) {
        const requestParams = {
            method: 'POST',
            body: JSON.stringify({
                accessType: MarketersHelper.getServerAccess(form.access),
                placeIds: [],
                productId: Number(form.product.productId)
            })
        };

        return this.apiManager
            .fetchMarketerAddProduct(marketerId, requestParams)
            .then(res => ({
                id: res.result.productId.toString(),
                access: MarketersHelper.getAccess(res.result.accessType)
            }));
    }

    public fetchChangeMarketerProduct(
        product: MarketerProduct,
        marketerId: string
    ) {
        const requestParams = {
            method: 'POST',
            body: JSON.stringify({
                accessType: MarketersHelper.getServerAccess(product.access),
                placeIds: [],
                productId: Number(product.id)
            })
        };

        return this.apiManager
            .fetchChangeMarketerAccess(marketerId, requestParams)
            .then(res => ({
                id: res.result.productId.toString(),
                access: MarketersHelper.getAccess(res.result.accessType)
            }));
    }

    public fetchRemoveMarketerProduct(productId: string, marketerId: string) {
        const requestParams = {
            method: 'POST',
            body: JSON.stringify([{ productId: Number(productId) }])
        };

        return this.apiManager
            .fetchRemoveMarketerAccess(marketerId, requestParams)
            .then(res => res.success);
    }
}
